import { createEffect, createEvent, restore, sample } from 'effector'

const fullscreenChangeCallback = createEvent<Event>()

const getFullscreenFx = createEffect(() => Boolean(document.fullscreenElement))

export const $isFullscreen = restore(getFullscreenFx.doneData, false)

sample({
  clock: fullscreenChangeCallback,
  target: getFullscreenFx,
})

document.addEventListener('fullscreenchange', fullscreenChangeCallback)
